import { DumbNonInvoicePaymentItem } from "./dumb-non-invoice-payment-item";

export class SubmitPaymentRequest {
    invoiceIds: number[];
    nonInvoicePayments: DumbNonInvoicePaymentItem[];
    paymentType: number;

    cardNumber: string;
    cardExpiration: string;
    cvv: string;
    billingStreet: string;
    billingStreet2: string;
    billingCity: string;
    billingState: string;
    billingZip: string;

    nameOnAccount: string;
    routingNumber: string;
    accountNumber1: string;
    accountNumber2: string;
    donationAmount: number;
}
